import * as React from 'react';
import { Dropdown, Menu, Input, Checkbox, Icon } from 'antd';
import InjectSheet from 'react-jss';

const styles = theme => ({
  blueButton: {
    borderRadius: '4px',
    background: '#c2ddfa',
  },
  clickable: {
    color: '#333333',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  menuItem: {
    '& .ant-menu-item': {
      marginBottom: '2px',
      marginTop: '0px',
      height : '28px !important',
    },
  },
});
class DropdownSelect extends React.PureComponent<any, any> {
  state = {
    userSearchVal: '',
    visible: false,
  };

  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  }

  handleChange = async (item) => {
    const { onChange, itemList } = this.props;
    let newItemList = [...itemList];
    if (!itemList.includes(item.key)) {
      newItemList.push(item.key);
    } else {
      newItemList = newItemList.filter(key => key !== item.key);
    }
    newItemList = newItemList.filter(this.onlyUnique);
    await onChange(newItemList);
  }

  handleSearch = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      userSearchVal : e.target.value,
    });
  }

  renderMenu = () => {
    const { userSearchVal } = this.state;
    const { classes, searchVisible, options, itemList } = this.props;
    const optionsToShow = options && options.filter(item =>
      JSON.stringify(item).toLowerCase().includes(userSearchVal.toLowerCase()));
    return <Menu>
        {searchVisible && <Menu.Item>
          <Input placeholder="Search User"
            onChange={this.handleSearch}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          />
        </Menu.Item>}
      <Menu style={{ maxHeight: '350px', overflow: 'scroll' }} className={classes.menuItem}>
      {optionsToShow && optionsToShow.map(item => <Menu.Item
        onClick={() => this.handleChange(item)}
        key={item.key}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Checkbox checked={itemList.includes(item.key)}/>
          <div style={{ marginLeft: '5px' }}> {item.label} </div>
        </div>
      </Menu.Item>)}
    </Menu>
    </Menu>;
  }

  handleVisibleChange = (flag) => {
    this.setState({
      visible: flag,
      userSearchVal: '',
    });
  }

  render() {
    const { classes, itemList, label } = this.props;
    const selectedCount = itemList && itemList.length;
    return <Dropdown
      trigger={['click']}
      visible={this.state.visible}
      placement="bottomLeft"
      onVisibleChange={this.handleVisibleChange}
      overlay={this.renderMenu()}>
      <div className={`${selectedCount ? classes.blueButton : {}}
      ${classes.clickable}`}>
        <div>{`${selectedCount ? selectedCount : ''}`} {label}</div>
        <Icon type="down" style={{ marginLeft: '3px' }}/>
      </div>
    </Dropdown>;
  }
}
export default InjectSheet(styles)(DropdownSelect);
